import dayjs from 'dayjs';

export const publishTimeFormat = (timestamp: number) => {
  const current = dayjs();
  const time = dayjs(timestamp);

  const isBeforeAnHour = time.isBefore(current.subtract(1, 'hour'));
  const isYesterday = time.isBefore(current.startOf('day'));
  const isLastYear = time.isBefore(current.startOf('year'));
  if (isLastYear) {// 去年
    return time.format('YYYY/MM/DD HH:mm');
  }
  if (isYesterday) {// 昨天
    return time.format('MM/DD HH:mm');
  }
  if (isBeforeAnHour) {// 一小时前 xx:xx
    return time.format('HH:mm');
  }
  const diffTime = current.diff(time);
  if (diffTime >= 1000 * 60) {
    // 一小时内 XX分钟前
    return `${current.diff(time, 'minute')}分钟前`;
  }
  return '刚刚';
};
